"use client";

import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox";

import { cn } from "@/utils/class-name";

function Checkbox({ className, ...props }: CheckboxPrimitive.Root.Props) {
    return (
        <CheckboxPrimitive.Root
            data-slot={"checkbox"}
            className={cn(
                "relative inline-flex size-4 shrink-0 items-center justify-center rounded-[0.25rem] border border-input bg-background bg-clip-padding shadow-xs ring-ring transition-shadow outline-none before:pointer-events-none before:absolute before:inset-0 before:rounded-[calc(0.25rem-1px)] not-disabled:not-data-checked:not-aria-invalid:before:shadow-[0_1px_--theme(--color-black/4%)] focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-64 aria-invalid:border-destructive/36 focus-visible:aria-invalid:border-destructive/64 focus-visible:aria-invalid:ring-destructive/48 dark:bg-clip-border dark:not-data-checked:bg-input/32 dark:not-disabled:not-data-checked:not-aria-invalid:before:shadow-[0_-1px_--theme(--color-white/8%)] dark:aria-invalid:ring-destructive/24 [&:is(:disabled,[data-checked],[aria-invalid])]:shadow-none",
                className,
            )}
            {...props}
        >
            <CheckboxPrimitive.Indicator
                data-slot={"checkbox-indicator"}
                className={
                    "absolute -inset-px flex items-center justify-center rounded-[0.25rem] text-primary-foreground data-checked:bg-primary data-indeterminate:text-foreground data-unchecked:hidden"
                }
                render={(renderProps, state) => (
                    <span {...renderProps}>
                        {state.indeterminate ? (
                            <svg
                                className={"size-3"}
                                xmlns={"http://www.w3.org/2000/svg"}
                                width={"24"}
                                height={"24"}
                                viewBox={"0 0 24 24"}
                                fill={"none"}
                                stroke={"currentColor"}
                                strokeWidth={"3"}
                                strokeLinecap={"round"}
                                strokeLinejoin={"round"}
                            >
                                <path d={"M5.252 12h13.496"} />
                            </svg>
                        ) : (
                            <svg
                                className={"size-3"}
                                xmlns={"http://www.w3.org/2000/svg"}
                                width={"24"}
                                height={"24"}
                                viewBox={"0 0 24 24"}
                                fill={"none"}
                                stroke={"currentColor"}
                                strokeWidth={"3"}
                                strokeLinecap={"round"}
                                strokeLinejoin={"round"}
                            >
                                <path d={"M5.252 12.7 10.2 18.63 18.748 5.37"} />
                            </svg>
                        )}
                    </span>
                )}
            />
        </CheckboxPrimitive.Root>
    );
}

export { Checkbox };
